import { twMerge } from "tailwind-merge";

import { ThumbIcon, Typography } from "~/common/components";
import {
  HandleRateSummaryProps,
  TreatmentRecommendations as treatmentRecommendationsType,
} from "~/providers/utils/types/patientIntakePreviewTypes";
import { SummaryType } from "~/providers/utils/types/patientPreviewTypes";
import { PreviewSectionLayout } from "../common/PreviewSectionLayout";

interface TreatmentRecommendationsProps {
  treatmentRecommendations: treatmentRecommendationsType;
  summaryType: SummaryType;
  onRate: (data: HandleRateSummaryProps) => void;
  isLike?: boolean;
  isRatePending?: boolean;
}

export const TreatmentRecommendations = ({
  treatmentRecommendations,
  onRate,
  summaryType,
  isLike,
  isRatePending,
}: TreatmentRecommendationsProps) => {
  const handleRate = (rate: boolean) => {
    if (isLike === rate) return onRate({ isLike: null, summaryType });
    onRate({ isLike: rate, summaryType });
  };

  return (
    <PreviewSectionLayout title="Treatment recommendations">
      <div className="flex flex-col gap-4 text-gray-70">
        <div>
          <Typography className="font-semibold">
            Cognitive behavioral therapy (CBT)
          </Typography>
          <p>{treatmentRecommendations.cognitive_behavioral_therapy}</p>
        </div>

        <div>
          <Typography className="font-semibold">
            Insight-oriented therapy
          </Typography>
          <p>{treatmentRecommendations.insight_oriented_therapy}</p>
        </div>

        <div className="flex flex-row gap-2">
          <button disabled={isRatePending} onClick={() => handleRate(true)}>
            <ThumbIcon
              className={twMerge(
                "size-4",
                isLike && "fill-primary-500 text-primary-500",
              )}
            />
          </button>
          <button disabled={isRatePending} onClick={() => handleRate(false)}>
            <ThumbIcon
              isDown
              className={twMerge(
                "size-4",
                isLike === false && "fill-primary-500 text-primary-500",
              )}
            />
          </button>
        </div>
      </div>
    </PreviewSectionLayout>
  );
};
